import { Link } from "react-router-dom";
import type { GossipItem } from "@/mocks/gossip";

const CAT_LABEL: Record<string, string> = {
  zongyi: "综艺",
  yingshi: "影视",
  yinyue: "乐坛",
  guancha: "观察",
};

export default function ArticleCard({ item }: { item: GossipItem }) {
  return (
    <article className="group flex flex-col overflow-hidden rounded-2xl border border-background-200/70 bg-background-100 transition-colors hover:border-primary-200">
      <Link to={`/detail/${item.id}`} className="relative block overflow-hidden">
        <div className="aspect-video w-full overflow-hidden bg-background-200">
          <img
            src={item.image}
            alt={item.title}
            loading="lazy"
            className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
          />
        </div>
        <span className="absolute left-3 top-3 rounded-full bg-foreground-950/70 px-2.5 py-1 text-xs font-semibold text-background-50 backdrop-blur">
          {CAT_LABEL[item.category] || "热点"}
        </span>
      </Link>

      <div className="flex flex-1 flex-col p-4 md:p-5">
        <h3 className="line-clamp-2 text-[15px] font-bold leading-snug text-foreground-950 md:text-base">
          <Link to={`/detail/${item.id}`} className="transition-colors group-hover:text-primary-600">
            {item.title}
          </Link>
        </h3>
        <p className="mt-2 line-clamp-2 text-sm leading-relaxed text-foreground-600">
          {item.summary}
        </p>
        <div className="mt-4 flex items-center gap-3 text-xs text-foreground-500">
          <span className="flex items-center gap-1">
            <i className="ri-fire-fill text-primary-500" aria-hidden="true"></i>
            {item.heat}
          </span>
          <span className="flex items-center gap-1">
            <i className="ri-eye-line" aria-hidden="true"></i>
            {item.views}
          </span>
          <span className="flex items-center gap-1 whitespace-nowrap">
            <i className="ri-time-line" aria-hidden="true"></i>
            {item.date}
          </span>
          <span className="ml-auto hidden items-center gap-1 whitespace-nowrap sm:flex">
            {item.readMinutes}分钟
            <i className="ri-arrow-right-line" aria-hidden="true"></i>
          </span>
        </div>
      </div>
    </article>
  );
}